import React from 'react';
import PageHeader from '#common/PageHeader';

import { ContactWrapper } from './Contact.style';

function Contact() {
  return (
    <ContactWrapper justify="center" align="center" id="contact">
      <PageHeader>Contact</PageHeader>
      <p style={{ textAlign: 'center', fontSize: 20 }}>
        Have a freelance project or job opportunity?{' '}
        <a href="mailto:samartekaya51@gmail.com" target="__blank" rel="noreferrer noopener">
          &nbsp;Email me.
        </a>
      </p>
    </ContactWrapper>
  );
}

export default Contact;
